import { makeSurfaceToken } from './token.surface.js';
import { makeGenericToken } from './util.make-generic-token.js';

function makeInteractiveSurfaceToken(propName, input) {
  const tokens = {
    default: makeSurfaceToken(`${propName}--default`, input.default),
    hover: makeSurfaceToken(`${propName}--hover`, input.hover),
    active: makeSurfaceToken(`${propName}--active`, input.active)
  };
  return makeGenericToken(function format(options) {
    switch (options?.state ?? "default") {
      case "default":
        return tokens.default(options);
      case "hover":
        return tokens.hover(options);
      case "active":
        return tokens.active(options);
    }
  }, function override(nextValue) {
    if (nextValue === undefined) {
      return {};
    }
    return {
      ...tokens.default.__override(nextValue.default),
      ...tokens.hover.__override(nextValue.hover),
      ...tokens.active.__override(nextValue.active)
    };
  }, function extend(propName, token) {
    return makeInteractiveSurfaceToken(propName, token);
  }, tokens);
}

export { makeInteractiveSurfaceToken };
//# sourceMappingURL=token.surface.interactive.js.map
